import { toValidCssValue } from "./toValidCssValue";
export var subtractCalc = function subtractCalc() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var valid = args.filter(v => !!v);
  if (!valid.length) return "0px";
  return valid.length === 1 ? toValidCssValue(valid[0]) : "calc(".concat(args.filter(item => !!item).map(toValidCssValue).join(" - "), ")");
};
export var plusCalc = function plusCalc() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var valid = args.filter(v => !!v);
  if (!valid.length) return "0px";
  return valid.length === 1 ? toValidCssValue(valid[0]) : "calc(".concat(args.filter(item => !!item).map(toValidCssValue).join(" + "), ")");
};